import React from "react";
import { Link, useLocation } from "react-router-dom";

export const Services = (props) => {
  const { pathname } = useLocation();

  const isExternal = (url = "") => /^https?:\/\//i.test(url);
  const isHash = (url = "") => url.startsWith("#");

  const normalizeLink = (url = "") => {
    if (!url) return "/";
    if (url.startsWith("/") || url.startsWith("#") || isExternal(url)) {
      return url;
    }
    return "/" + url; // convierte "cumpleanos" en "/cumpleanos"
  };

  const onHashClick = (hash, e) => {
    if (pathname === "/") {
      e.preventDefault();
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Nuestros Servicios</h2>
          <p>
            Ofrecemos una amplia gama de servicios para satisfacer las
            necesidades de nuestros clientes.
          </p>
        </div>

        <div className="row">
          {props.data
            ? props.data.map((d, i) => {
                const url = normalizeLink(d.link);
                return (
                  <div key={`${d.name}-${i}`} className="col-md-4">
                    {isExternal(url) ? (
                      <a
                        href={url}
                        className="service-card"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className={d.icon} />
                        <div className="service-desc">
                          <h3>{d.name}</h3>
                          <p>{d.text}</p>
                        </div>
                      </a>
                    ) : isHash(url) ? (
                      <a
                        href={url}
                        className="service-card"
                        onClick={(e) => onHashClick(url, e)}
                      >
                        <i className={d.icon} />
                        <div className="service-desc">
                          <h3>{d.name}</h3>
                          <p>{d.text}</p>
                        </div>
                      </a>
                    ) : (
                      <Link to={url} className="service-card">
                        <i className={d.icon} />
                        <div className="service-desc">
                          <h3>{d.name}</h3>
                          <p>{d.text}</p>
                        </div>
                      </Link>
                    )}
                  </div>
                );
              })
            : "loading"}
        </div>
      </div>
    </div>
  );
};
